import { Serializable, JsonProperty } from "typescript-json-serializer";

type ICountryName = { name: string };
type IState = { 
    name: string,
    code: string,
};

@Serializable()
export class AddressDto {

    @JsonProperty() id?: number;

    @JsonProperty() firstName: string;

    @JsonProperty() lastName: string;

    @JsonProperty() countryCode2: string;

    @JsonProperty({
        beforeDeserialize: (countryName: ICountryName | string) => {
            return typeof countryName == "object" ? countryName.name : countryName;
        },
    })
    countryName: string;
    
    @JsonProperty({
        beforeDeserialize: (stateCode: IState | string) => {
            if (stateCode && typeof stateCode == "object") {
                return stateCode.code;
            } else if (typeof stateCode == "string" && stateCode != "" && stateCode.length == 2) {
                return stateCode;
            } else {
                return "";
            }
        },
    })
    stateCode?: string;

    @JsonProperty({
        beforeDeserialize: (state: IState | string) => {
            return typeof state == "object" ? state.name : state;
        },
    })
    state?: string;
    
    
    @JsonProperty({
        beforeDeserialize: (state: IState | string) => {
            return typeof state == "object" ? state.name : state;
        },
    })
    stateName?: string;

    @JsonProperty() city?: string;

    @JsonProperty() suburb?: string;

    @JsonProperty() streetAddress1: string;

    @JsonProperty() streetAddress2?: string;

    @JsonProperty() postcode?: string;

    @JsonProperty() locationType: string;
    
    @JsonProperty() locationTypeCode?: string;
    
    @JsonProperty() locationTypeValue?: string;

    @JsonProperty() mobile?: string;

    @JsonProperty() telephone: string;

    @JsonProperty() company?: string;

    @JsonProperty() emailAddress: string;

    @JsonProperty() isDefault?: boolean;

    @JsonProperty() label?: Array<string>;
}